
import React from 'react';
import { Link } from 'react-scroll';
// import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-6">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <h3 className="text-xl font-semibold">Max Hauling</h3>
          <p>&copy; 2025 Max Hauling. All rights reserved.</p>
        </div>
        {/* <div className="flex space-x-4 mb-4 md:mb-0">
          <a href="www.facebook.com" className="text-blue-500 hover:text-white">
            <FaFacebook className="text-2xl" />
          </a>
          <a href="www.twitter.com" className="text-blue-500 hover:text-white">
            <FaTwitter className="text-2xl" />
          </a>
          <a href="www.instagram.com" className="text-blue-500 hover:text-white">
            <FaInstagram className="text-2xl" />
          </a>
          <a href="www.linkedin.com" className="text-blue-500 hover:text-white">
            <FaLinkedin className="text-2xl" />
          </a>
        </div> */}
        <div>
          <ul className="space-y-2">
            <li>
              <Link
                to="hero"
                smooth={true}
                duration={500}
                offset={-70}
                className="cursor-pointer text-blue-500 hover:underline"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="services"
                smooth={true}
                duration={500}
                offset={-70}
                className="cursor-pointer text-blue-500 hover:underline"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="about"
                smooth={true}
                duration={500}
                offset={-70}
                className="cursor-pointer text-blue-500 hover:underline"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                offset={-70}
                className="cursor-pointer text-blue-500 hover:underline"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
